import { render, staticRenderFns } from "./vehiclecheckviewdata.html?vue&type=template&id=0afe27d8&scoped=true&external"
import script from "./vehiclecheckviewdata.vue?vue&type=script&lang=js"
export * from "./vehiclecheckviewdata.vue?vue&type=script&lang=js"
import style0 from "./vehiclecheckviewdata.vue?vue&type=style&index=0&id=0afe27d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afe27d8",
  null
  
)

export default component.exports